import React, { Component } from 'react';
import Search from '../../components/Search';
import DataTable from '../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../actions/search';
import {fileMetaDataValueFetchData, fileMetaDataCategoryFetchData} from '../../actions/fileData'
import Loader from '../../components/Loader';
import { setSearchScope } from '../../helpers';
class FileMetaDataValue extends Component {

	constructor(props,context) {
        super(props,context);

        this.additionalColumns = [{
            Header: 'Is een urgente notificatie?',
            accessor: 'is_notifier',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },{
            Header: 'Is actief?',
            accessor: 'is_active',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        }, {
            Header: 'Aanpassen',
            accessor: 'id',
            Cell: props => <span><a href={'/#/fileMetaDataValue/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-pencil"></i> Bewerken</a></span>
        }
        ]

        this.columns = [
			{Header: "ID", accessor: "id"},
			{Header: "Categorie", accessor: "category_name"},
			{Header: "Waarde", accessor: "name"}
		];
    }

    componentWillMount() {
		setSearchScope('fileMetaDataValue');
        if(this.props.clientPath.clientPath) {
			this.props.updateSearchData(this.props.fileMetaDataValue.data)
            this.props.fileMetaDataValueFetchData(this.props.clientPath.clientPath)
            this.props.fileMetaDataCategoryFetchData(this.props.clientPath.clientPath);

        }

      }

     componentDidUpdate(prevProps) {
		if ( JSON.stringify(prevProps.fileMetaDataValue) !== JSON.stringify(this.props.fileMetaDataValue) ) {
            this.props.updateSearchData(this.props.fileMetaDataValue.data)
            this.columns = this.props.fileMetaDataValue.columns
        }
    }

	render() {
          const filterValues = {
            isActive : {
                name: 'Is Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '1'
            },
            isNotActive : {
                name: 'Niet Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '0'
            }
        }
        return (
            <Card>
				<CardHeader><Search filters={filterValues} data={this.props.fileMetaDataValue.data} keys_to_filter={['name']}/></CardHeader>
                <CardBody>
                    <CardTitle><i className="fa fa-align-justify"></i> Metadata waarde overzicht</CardTitle>
                    {this.columns ? <DataTable additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.fileMetaDataValue.data} columns={this.columns} /> : <Loader /> }
                </CardBody>
            </Card>
        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
       fileMetaDataValue: state.FileMetaDataValueReducer,
       searchData: state.SearchDataReducer,
       clientPath: state.clientPathReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        fileMetaDataValueFetchData: (url) => dispatch(fileMetaDataValueFetchData(url + '/api/files/action/getFileMetaDataValue')),
        fileMetaDataCategoryFetchData: (url) => dispatch(fileMetaDataCategoryFetchData(url + '/api/files/action/getFileMetaDataCategories')),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileMetaDataValue)



// WEBPACK FOOTER //
// ./src/views/Filemetadatavalue/index.js